export default  {"src":"/_next/static/image/public/images/padlock.b631b0259370223b4f75a107919ecd06.svg","height":16,"width":13};